export const csvHeadings = [
    {
        label: "Transaction Id",
        key: "transaction_id"
    },
    {
        label: "Order date",
        key: "order_date"
    },
    {
        label: "Ship to",
        key: "customer_account_number"
    },
    {
        label: "Bill to",
        key: "customer_billto_account_number"
    },
    {
        label: "Loyalty Id",
        key: "loyalty_id"
    },
    {
        label: "Type",
        key: "type"
    },
    {
        label: "Transaction Type",
        key: "transaction_type"
    },
    {
        label: "Transaction Status",
        key: "transaction_status"
    },
    
]